import { render } from "./ApiTokenNew.vue?vue&type=template&id=e62e23b4"
import script from "./ApiTokenNew.vue?vue&type=script&lang=js"
export * from "./ApiTokenNew.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fLte45evJ/0/trinax/jeopardy.trinax.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__